export default __webpack_public_path__ + "static/media/nuonic-logo.87647576.svg";